import { render, staticRenderFns } from "./AddPayingEnterprise.vue?vue&type=template&id=2220ce63&scoped=true&"
import script from "./AddPayingEnterprise.vue?vue&type=script&lang=js&"
export * from "./AddPayingEnterprise.vue?vue&type=script&lang=js&"
import style0 from "./AddPayingEnterprise.vue?vue&type=style&index=0&id=2220ce63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2220ce63",
  null
  
)

export default component.exports